import type { SectionConfig } from "@/v2/framework/registry/types";

export default {
  name: "settings",
  title: "backoffice.settings",
  position: 1,
} satisfies SectionConfig;
